import React from 'react';
import './Header.css';
import FileNameBox from '../FileNameBox/FileNameBox';
import TogglePreview from './TogglePreview/TogglePreview';
import LinksAndCurrentLocation from '../../components/LinksAndCurrentLocation/LinksAndCurrentLocation';

const Header = ({ templateName }) => {
    return (
    <header className="header">
        <div className="header__group">
            <FileNameBox value={templateName} />
        </div>
        <React.Fragment>
            <div className='header__option'>
                <LinksAndCurrentLocation />
            </div>
        </React.Fragment>
        <TogglePreview /> 
    </header>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js